import * as React from "react";

import Head from "../components/Head";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Concert from "../components/Concert";
import News from "../components/News";
import About from "../components/About";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import OGP from "../images/ogp.png";

// markup

const IndexPage = () => {
  return (
    <div>
      <Head img_url={`https://etc4th.site${OGP}`} />
      <Header />
      <Hero />
      <Concert />
      <News />
      <About />
      <Contact />
      <Footer inIndex={true} />
    </div>
  );
};

export default IndexPage;
